import { Browser } from '../../types/Browser.type'

export function getBrowser(): Browser {
  const userAgent = navigator.userAgent

  if (/Edg\//.test(userAgent) || /EdgiOS\//.test(userAgent)) {
    return Browser.EDGE
  } else if (/Firefox\//.test(userAgent) || /FxiOS\//.test(userAgent)) {
    return Browser.FIREFOX
  } else if (/OPR\//.test(userAgent)) {
    return Browser.OPERA
  } else if (
    /Safari\//.test(userAgent) &&
    !/Chrome\//.test(userAgent) &&
    !/CriOS\//.test(userAgent)
  ) {
    return Browser.SAFARI
  } else if (
    (/Chrome\//.test(userAgent) || /CriOS\//.test(userAgent)) &&
    !/Edg\//.test(userAgent)
  ) {
    return Browser.CHROME
  } else if (/MSIE|Trident\//.test(userAgent)) {
    return Browser.IE
  } else {
    return Browser.UNKNOWN
  }
}
